module.exports = __webpack_public_path__ + "img/eighty-one.38a79eef.png";